import { Observable } from 'rxjs/Observable';
import { SkillService } from '../../services/skill.service';
import { BaseCondition } from './base.condition';
import { NotificationService } from '../../services';
import { ConditionFailReason, Options } from '../../models';

export class SkillAvailableCondition extends BaseCondition {
  constructor(options: Options, public skillService: SkillService, notificationService: NotificationService) {
    super("SkillAvailableCondition", notificationService);
    this.observable = new Observable(observer => {
      this.skillService.getSkillStatus([options.DefaultSkillAddressName]).subscribe(skill => {
        console.log(`fetched ${skill.length} item(s) for '${options.DefaultSkillAddressName}' skill`);
        if (options.AgentAvailability.MaxWaitTimeSeconds && skill[0].WaitTimeSeconds > options.AgentAvailability.MaxWaitTimeSeconds) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} wait time is too long`);
          observer.next(false);
          return;
        }
          if (options.AgentAvailability.MinAgentCapacity && skill[0].AvailableCapacity && skill[0].AvailableCapacity < options.AgentAvailability.MinAgentCapacity) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} does not have enough agent capacity`);
          observer.next(false);
          return;
        }
        if (options.AgentAvailability.MinActiveAgents && skill[0].ActiveUsers < options.AgentAvailability.MinActiveAgents) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} does not have enough active agents`);
          observer.next(false);
          return;
        }
        if (options.AgentAvailability.WithinBusinessHour && (skill[0].WithinBusinessHour !== options.AgentAvailability.WithinBusinessHour)) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} have no agent within Business hours`);
          observer.next(false);
          return;
        }
          if (options.AgentAvailability.MinCloseTimeInSeconds && skill[0].CloseInSeconds  && skill[0].CloseInSeconds < options.AgentAvailability.MinCloseTimeInSeconds) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} will be closing soon`);
          observer.next(false);
          return;
        }
          if (options.AgentAvailability.MinCapacityPercentage && skill[0].CapacityPercentage && skill[0].CapacityPercentage < options.AgentAvailability.MinCapacityPercentage) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} does not have enough capacity percentage`);
          observer.next(false);
          return;
        }
        if (options.AgentAvailability.Status && (skill[0].Status !== options.AgentAvailability.Status.toLowerCase())) {
          this.onConditionFail(ConditionFailReason.CriteriaFail, `${options.DefaultSkillAddressName} status not matched`);
          observer.next(false);
          return;
        }
        console.log(`Checking Skill availability for skill '${options.DefaultSkillAddressName}' passed`);
        observer.next(true);
      },
        err => {
          this.onConditionFail(ConditionFailReason.ServerError, `Failed to get skill status due to error ${err}`);
          observer.next(false);
        });
    });
  }
}
